/**
 * Copyright (c) Microsoft. All rights reserved.
 */

/* eslint-disable no-bitwise */
/**
 * Creates a function that takes an item T and normalizes
 * the given key from a given object of type T if the value
 * of the key was of string type.
 *
 * @param key The key to index the item given.
 * @param item The item to index.
 * @returns If item[key] was a string value, the string is
 * normalized. Else it is returned as is.
 */
export const createKeyedStringNormalizer = <T>(key: keyof T) => (item: T) => {
    const value = item[key];

    if (typeof value === 'string') {
        return value.toLocaleLowerCase();
    }

    return item[key];
};

/**
 * Generates a hash number from the
 * given string.
 *
 * @param str The string to hash
 */
export const getHash = (str: string): number => {
    let hash = 0;
    let i;
    let chr;

    if (str.length === 0) {
        return hash;
    }

    for (i = 0; i < str.length; i++) {
        chr = str.charCodeAt(i);
        hash = (hash << 5) - hash + chr;
        hash |= 0;
    }

    return hash;
};
